import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "position-absolute d-flex",
  style: {"justify-content":"center","align-items":"center","height":"100vh","width":"100%","background-color":"rgba(0, 0, 0, 0.8)","z-index":"2"}
}
const _hoisted_2 = { class: "optionsContainer bg-primary" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Options:")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", null, "Save Changes", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", null, "Revert Changes", -1)

import { ref, watch } from "vue";
import { useTheme } from "vuetify";


export default /*#__PURE__*/_defineComponent({
  __name: 'Options',
  props: ["username"],
  emits: ["changed-theme", "guest-changed", "username-changed", "time-chart-change", "hideOptions", "statsModeChanged"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
let newUsername = ref<string>(props.username);

watch(
    () => props.username,
    (username: string) => {
        newUsername.value = username.toLowerCase();
    },
);

const jscookie = require("js-cookie");
const themeChanger = useTheme();
const selectThemeItems: string[] = ["dark", "light", "red", "pink", "purple", "deep-purple", "indigo", "blue", "light-blue", "cyan", "teal", "green", "light-green", "lime", "yellow", "amber", "orange", "deep-orange", "brown", "blue-grey"];
const selectStatsItems: { title: string; value: number }[] = [
    {
        title: "All times",
        value: -1,
    },
    {
        title: "Today",
        value: 1,
    },
];
let theme = ref<string>(jscookie.get("theme") ?? "dark");
let newTheme = ref(theme.value);
let isGuest = ref<boolean>(jscookie.get("isGuest") === "1");
let statsMode = ref<number>(Number(jscookie.get("statsMode")) ?? -1);

if (isNaN(statsMode.value)) {
    statsMode.value = -1;
}

jscookie.get("timeChartActive") === undefined
    ? jscookie.set("timeChartActive", 1, {
          expires: 365 * 10,
      })
    : null;
let timeChartActive = ref<boolean>(jscookie.get("timeChartActive") === "1");

function changeTheme() {
    theme.value = newTheme.value;
    themeChanger.global.name.value = theme.value;
    jscookie.set("theme", theme.value, {
        expires: 365 * 10,
    });
    emit("changed-theme", theme.value);
}

function changeIsGuest() {
    jscookie.set("isGuest", Number(isGuest.value), {
        expires: 365 * 10,
    });
    if (jscookie.get("isGuest") !== "1") {
        emit("guest-changed", newUsername.value);
    }
}

function changeStatsMode() {
    jscookie.set("statsMode", Number(statsMode.value), {
        expires: 365 * 10,
    });
    emit("statsModeChanged");
}

function changeTimeChartActive() {
    jscookie.set("timeChartActive", Number(timeChartActive.value), {
        expires: 365 * 10,
    });
}

function revertChanges() {
    newUsername.value = props.username;
    newTheme.value = theme.value;
    isGuest.value = jscookie.get("isGuest") === "1";
    timeChartActive.value = jscookie.get("timeChartActive") === "1";
    statsMode.value = Number(jscookie.get("statsMode")) ?? -1;
}

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_v_divider, {
          class: "my-3",
          thickness: 3,
          length: "90%"
        }),
        _createElementVNode("div", null, [
          _createVNode(_component_v_checkbox, {
            label: "Use as guest",
            modelValue: _unref(isGuest),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isGuest) ? (isGuest).value = $event : isGuest = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_text_field, {
            "hide-details": "auto",
            label: "Type in your username",
            style: {"width":"400px"},
            modelValue: _unref(newUsername),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(newUsername) ? (newUsername).value = $event : newUsername = $event)),
            disabled: _unref(isGuest),
            "prepend-inner-icon": "mdi-account-circle"
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _createVNode(_component_v_divider, {
          class: "my-3",
          thickness: 3,
          length: "90%"
        }),
        _createElementVNode("div", null, [
          _createVNode(_component_v_checkbox, {
            label: "Show the Time Chart",
            modelValue: _unref(timeChartActive),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(timeChartActive) ? (timeChartActive).value = $event : timeChartActive = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_select, {
            label: "Change Theme",
            items: selectThemeItems,
            modelValue: _unref(newTheme),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(newTheme) ? (newTheme).value = $event : newTheme = $event)),
            "prepend-inner-icon": "mdi-palette",
            "hide-details": "",
            style: {"width":"400px"},
            class: "mb-1"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_select, {
            label: "Show stats for:",
            items: selectStatsItems,
            modelValue: _unref(statsMode),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(statsMode) ? (statsMode).value = $event : statsMode = $event)),
            "hide-details": "",
            style: {"width":"400px"},
            class: "mb-1"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_v_divider, {
          class: "my-3",
          thickness: 3,
          length: "90%"
        }),
        _createElementVNode("div", null, [
          _createVNode(_component_v_btn, {
            style: {"width":"200px","margin-right":"10px"},
            color: "background",
            onClick: _cache[5] || (_cache[5] = ($event: any) => {
                            emit('hideOptions'); /* hide options */
                            changeTheme();
                            /* toggle timeChart*/
                            changeTimeChartActive();
                            emit('time-chart-change', _unref(timeChartActive));
                            /* change username */
                            _isRef(newUsername) //@ts-ignore
 ? newUsername.value = _unref(newUsername).replaceAll(/\s/g, '') : newUsername = _unref(newUsername).replaceAll(/\s/g, '');
                            _unref(newUsername).length > 0 && !_unref(newUsername).startsWith('wca-') ? (!(_unref(newUsername).length > 28) ? emit('username-changed', _unref(newUsername)) : _unref(newUsername).substring(0, 28)) : (_isRef(newUsername) //@ts-ignore
 ? newUsername.value = props.username : newUsername = props.username);
                            /* toggle guest mode*/
                            changeIsGuest();
                            /* toggle stats mode*/
                            changeStatsMode();
                        })
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            style: {"width":"200px"},
            color: "background",
            onClick: _cache[6] || (_cache[6] = ($event: any) => {
                            revertChanges();
                            emit('hideOptions');
                        })
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})